import { VariantProps } from 'cva';
import { ComponentProps } from 'react';

import { cva } from '../cva';

const variants = cva({
    base: [
        'prose max-w-none text-pretty break-words leading-normal text-inherit',
        'prose-h1:text-3xl prose-h1:md:text-4xl prose-h1:lg:text-5xl',
        'prose-h1:relative prose-h1:pb-3 prose-h1:font-bold prose-h1:after:absolute prose-h1:after:w-[126px] prose-h1:after:inset-x-0 prose-h1:after:bottom-0 prose-h1:after:h-1 prose-h1:after:rounded-full prose-h1:after:bg-gradient-to-r prose-h1:after:from-[--gradient-end] prose-h1:after:to-[--gradient-start]',
        'prose-h2:text-2xl prose-h2:md:text-3xl prose-h2:lg:text-4xl',
        'prose-h3:text-xl prose-h3:md:text-2xl prose-h3:lg:text-3xl',
        'prose-h4:text-lg prose-h4:md:text-xl prose-h4:lg:text-2xl',
        'prose-strong:text-inherit',
        'prose-a:text-blue prose-a:transition prose-a:font-inherit prose-a:underline-offset-2 hover:prose-a:text-gray',
        'dark:prose-a:text-white dark:hover:prose-a:text-gray-100',
    ],
});

type ProseVariantProps = VariantProps<typeof variants>;

export type ProseProps = Omit<ComponentProps<'div'>, keyof ProseVariantProps> &
    ProseVariantProps;

export function Prose(props: ProseProps) {
    return <div {...props} className={variants(props)} />;
}
